import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsHeaderResponsiveComponent } from './news-headerResponsive.component';
import { BlockHorizontalScrollerModule } from '@shared/components/block-horizontal-scroller/block-horizontal-scroller.module';
import { NewsBlockModule } from '@news/views/news-block/news-block.module';
import { NewsGQL } from '@shared/services/news/news.gql.service';
import { FullHeaderSliderComponent } from 'app/layout/components/full-header-slider/full-header-slider.component';

@NgModule({
    imports: [
        CommonModule,
        FullHeaderSliderComponent,
        BlockHorizontalScrollerModule,
        NewsBlockModule,
        NewsHeaderResponsiveComponent
    ],
    exports: [
        NewsHeaderResponsiveComponent
    ],
    providers: [NewsGQL]
})
export class NewsHeaderResponsiveModule { }
